
import { defineComponent } from 'vue'
import { WebhookEventTypes } from '~/types/types'
import { fromNow } from '~/utils/date'

export default defineComponent({
  name: 'WebhookLogListItem',
  props: {
    id: {
      type: String,
      required: true
    },
    httpStatusCode: {
      type: Number,
      default: null
    },
    eventType: {
      type: Object as () => WebhookEventTypes,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    finishedIn: {
      type: String,
      required: true
    }
  },
  methods: { fromNow }
})
